import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-enter",
  "use": "icon-enter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-enter\"><path d=\"M812 642.7c-12.9 0.2-23.3 10.8-23.1 23.7v59.5c0 26-20.6 47.2-46 47.2H283.2c-25.4 0-46-21.2-46-47.2V301.4c0-26 20.6-47.2 46-47.2h160l59.4 105.7c4.8 8.4 13.8 12.7 22.7 11.7h217.5c25.4 0 46 21.2 46 47.2v59c0 13.1 10.4 23.7 23.2 23.7 12.8 0 23.1-10.6 23.1-23.7 0-0.6 0-1.2-0.1-1.8v-57.2c0-52.1-41.2-94.4-92-94.4H535.9l-59.3-105.3c-5.3-9.5-12.9-12-19.6-11.8l-0.1-0.1h-174c-50.8 0-92 42.3-92 94.4v423.3c0 52.1 41.2 94.4 92 94.4H743c50.8 0 92-42.3 92-94.4v-56.7c0.1-0.6 0.1-1.2 0.1-1.8 0.1-6.2-2.3-12.2-6.7-16.6-4.3-4.5-10.2-7-16.4-7.1z\" p-id=\"2704\" /><path d=\"M485.9 471.2c-3.7-4-8.8-6.3-14.3-6.3-5.4 0-10.6 2.3-14.3 6.3l-85.2 90.7-0.5 0.5h-0.1l-0.5 0.5c-7.7 8.5-7.7 21.5 0 30l85.5 91.2c3.6 4 8.7 6.2 14.1 6.3 5.4 0 10.5-2.2 14.1-6.2l0.4-0.5c7.7-8.5 7.7-21.5 0-30l-51.5-55h233.9c10.9 0 19.8-9.5 19.8-21.1 0-11.6-8.9-21.1-19.8-21.1h-233l51.4-54.9c7.9-8.5 7.9-21.8 0-30.4z\" p-id=\"2705\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/enter.svg
// module id = HS6h
// module chunks = 42